import { apiRequest } from './client';

export const listImages = (token) => apiRequest('/images', { token });

export const generateImage = (token, payload) =>
  apiRequest('/images', { method: 'POST', token, body: payload });

export const fetchDefaultPrompt = (token) => apiRequest('/prompt', { token });

export const createDraftImage = (token, payload) =>
  apiRequest('/images/draft', { method: 'POST', token, body: payload });

export const deleteImage = (token, id) =>
  apiRequest(`/images/${id}`, { method: 'DELETE', token });
